<template>
  <div id="tickets">

    <Datatable
        v-if="inventory"
        entity="custom_item"
        class="datatable"
        ref="datatable"
        :parameters="{inventory: inventory.id,  company: company, class: 'aims'}"
        :onRowClick="onRowClick"
        :globalActions="[
            {text: 'ticket.new', method: onCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }},
            ]"
        :rowActions="[
        {text: 'edit', method: onRowEdit },
        {text: 'delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }}
      ]">
    </Datatable>

    <Modal
        name="delete-confirmation"
        :title="$t('categories.confirmation')"
        dismissable
        :actions="[{name: $t('back'), action: 'close'}, {name: $t('datatable.delete'), action: deleteItem, primary: true}]">
      <p>{{$t('ticket.delete_message')}} <b>{{actionRow.name}}</b></p>
    </Modal>


  </div>
</template>

<script>
import Datatable from "@/components/Datatable.vue";
import {mapActions} from "vuex";

export default {
  name: "tickets",

  components: { Datatable },

  data() {
    return {
      actionRow: {},
      entityName: 'custom_items'
    }
  },

  computed: {
    inventory() {
      return this.$store.state.contextInventory;
    },
    company() {
      return this.$route.query.company || undefined;
    }
  },

  async mounted() {
    this.$store.state.pageTitleTranslationKey = "ticket.title";
    this.$store.state.pageIcon = "/icon/ticket.svg";
  },

  methods: {
    ...mapActions(["deleteInventoryEntity"]),

    onRowClick(row) {
      this.$router.push(this.$router.buildContext('/aims-ticket/edit', {id: row.id}));
    },
    onRowEdit(row) {
      this.onRowClick(row);
    },
    onRowDelete(row) {
      this.actionRow = row;
      this.$modal.show("delete-confirmation");
    },
    async deleteItem() {
      this.$store.commit("showSpinner", true);
      let response = await this.deleteInventoryEntity({entity: this.entityName, inventory: this.inventory.id, id: this.actionRow.id});
      if (response) {
        this.$modal.show("delete-confirmation", false);
        this.$refs.datatable.query();
        this.$store.commit("showSpinner", false);
      } else {
        this.$modal.show("delete-confirmation", false);
        toast(this.$t("error.no_server"),"error");
        this.$store.commit("showSpinner", false);
      }
    },
    onCreate() {
      this.$router.push(this.$router.buildContext('/aims-ticket/new'));
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
